<template>
  <hsc-window-style-white>
    <hsc-window
      :title="title"
      :closeButton="true"
      :resizable="true"
      :isScrollable="true"
      :isOpen.sync="open"
      positionHint="center"
      :minWidth="1250"
      :minHeight="750"
    >
    <b-container fluid>
      <b-tabs content-class="mt-3">
        <b-tab class="acl-body" title-item-class="acl-tab" title="Who can see this Page">
          <b-table small :items="currentPagePermissions" :fields="currentPagePermissionsFields">
            <template v-slot:cell(checkbox)="data">
              <b-form-checkbox v-model="data.item.viewable" @change="updatePagePermissions(data.item.roleId, data.item.rolePageId, data.item.viewable)"></b-form-checkbox>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-container>
    </hsc-window>
  </hsc-window-style-white>
</template>

<script>

import store from '@/store'

export default {
  name: 'PageAdministrationOverlay',
  data () {
    return {
      open: true,
      title: 'Administration Settings',
      currentPagePermissionsFields: [
        {key: 'checkbox', label: ''},
        {key: 'role', label: 'Role', sortable: true}
      ]
    }
  },
  computed: {
    currentPageId () {
      return store.state.currentPageId
    },
    currentPagePermissions () {
      return store.state.acl.currentPagePermissions
    }
  },
  methods: {
    updatePagePermissions (roleId, rolePageId, viewable) {
      switch (viewable) {
        case true:
          this.createPagePermission(roleId)
          break
        case false:
          this.deletePagePermission(rolePageId)
          break
      }
    },
    createPagePermission (roleId) {
      const payload = {roleId: roleId, pageId: this.currentPageId}
      store.dispatch('acl/createACLRolePage', payload)
    },
    deletePagePermission (rolePageId) {
      store.dispatch('acl/deleteACLRolePage', rolePageId)
    }
  },
  beforeMount () {
    store.dispatch('acl/fetchACLPagePermissions', this.currentPageId)
  }
}
</script>

<style scoped>

</style>
